import { Result } from '@empathy/search-types';
import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { EmpathyXConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { TRACKING_ACTIONS_KEYS } from '../tracking.const';
import { TrackingAction, TrackingContext } from '../tracking.interfaces';

export class MoveResultToSessionStorageAction implements TrackingAction {

  private localStorageService: StorageService;
  private sessionStorageService: StorageService;

  actions = {
    [TRACKING_ACTIONS_KEYS.moveResultToSessionStorage]: ({ state, rootGetters }: TrackingContext) => {
      this.initDependencies();
      const { tracking }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];

      if (state.productPageResultId) {
        const result = this.localStorageService.removeItem<Result>(state.productPageResultId);
        if (result) {
          return this.sessionStorageService.setItem(tracking.addToCart.storage.result, result);
        }
      }

      this.sessionStorageService.removeItem(tracking.addToCart.storage.result);
    }
  };

  private initDependencies() {
    this.localStorageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
    this.sessionStorageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Session);
  }
}
